"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EValidationError = void 0;
exports.EValidationError = {
    isInt: "isInt",
    min: "min",
    max: "max",
    isNumber: "isNumber",
    isEnum: "isEnum",
    isObject: "isObject",
    isArray: "isArray",
    isBoolean: "isBoolean",
    isNotEmpty: "isNotEmpty",
    isString: "isString",
    isPositive: "isPositive",
    maxLength: "maxLength",
    isEmail: "isEmail",
    isPhoneNumber: "isPhoneNumber",
    isNumberString: "isNumberString",
    bankAbaInvalid: "bankAbaInvalid",
    arrayNotEmpty: "arrayNotEmpty",
    emailNotExists: "emailNotExists",
    pinCodeNotValid: "pinCodeNotValid",
    badCredentials: "badCredentials",
    wrongPassword: "wrongPassword",
    passwordNotMatch: "passwordNotMatch",
    isStrongPassword: "isStrongPassword",
    uniqueEmail: "uniqueEmail",
    roleNotExists: "roleNotExists",
    productNotExists: "productNotExists",
    simulatorInvalidExposure: "simulatorInvalidExposure",
    clientNotExists: "clientNotExists",
    clientSheetNotExists: "clientSheetNotExists",
    oneClientSheetNotExists: "oneClientSheetNotExists",
    productSubscribedNotExists: "productSubscribedNotExists",
    mustBeInThePast: "mustBeInThePast",
    mustBeInTheFuture: "mustBeInTheFuture",
    counterSignatureRequired: "counterSignatureRequired",
    productSheetNotExists: "productSheetNotExists",
    subscriberNotSame: "subscriberNotSame",
    subscriptionNotExists: "subscriptionNotExists",
    match: "match",
    uniqueSiret: "uniqueSiret",
    officeNotExists: "officeNotExists",
    minLength: "minLength",
    isIBAN: "isIBAN",
    isDate: "isDate",
    isBIC: "isBIC",
    isUuid: "isUuid",
    productNotAvailable: "productNotAvailable",
    emailNotFound: "emailNotFound",
    emailCaseSensitive: "emailCaseSensitive",
    percentageTotalMustBe100: "percentageTotalMustBe100",
    fileNotExists: "fileNotExists",
    notInAdequationWithInvestment: "notInAdequationWithInvestment",
    mustIncludeBicOrIrppOrBnc: "mustIncludeBicOrIrppOrBnc",
    personUSmustBeFalse: "personUSmustBeFalse",
    corporationNotExists: "corporationNotExists",
    incompleteSubscriber: "incompleteSubscriber",
    legacyPaidSubscriptionReadOnly: "legacyPaidSubscriptionReadOnly",
    blockOperation: "blockOperation",
    mustBeLessOrEqualChildren: "mustBeLessOrEqualChildren",
    associationProfessionnelleNotExists: "associationProfessionnelleNotExists",
    isSameEmailThanSpouse: "isSameEmailThanSpouse",
    isSamePhoneThanSpouse: "isSamePhoneThanSpouse",
    userNotExists: "userNotExists",
};
